<template>
  <v-layout wrap>

    <loading-component :value="loading !== 0"/>
    <v-dialog :value="!!activeRideId" lazy @input="activeRideId = null">
      <ride-page v-if="activeRideId" show_end_ride :ride_id="activeRideId"/>
    </v-dialog>
    <v-flex :sm10='showRefused' :sm12="hideRefused">
      <div>
                <span
                    v-for="(color,state) in bookingColors"
                    class="color-identifier"
                    :style="'background-color: '+color+';min-width: 10px;padding: 3px 7px;font-size: 12px;font-weight: 700;line-height: 1;color: #fff;text-align: center;white-space: nowrap;vertical-align: middle;border-radius: 10px;'">{{
                    state
                  }}</span>

      </div>
      <div>
        <v-btn flat color="primary" @click="dialog = 'checker'">
          Captain Checker
        </v-btn>
        <!--                <v-btn flat color="primary" @click="dialog = 'start-shift'">-->
        <!--                    Captain Start shift-->
        <!--                </v-btn>-->
        <v-btn v-if="refused_requests.length > 0" flat @click="hideRefused = !hideRefused" color="red">
          <template v-if="!hideRefused">Hide</template>
          <template v-else>Show</template>
          Refused
        </v-btn>
      </div>
      <v-container>
        <v-range-slider
            v-model="range"
            thumb-label="always"
            :step="step"
            label="Range"
            :min="min_range"
            :max="max_range"
        />

      </v-container>
      <full-calendar
          ref="calendar"
          default-view="resourceTimelineDay"
          resource-label-text="Captains"
          resource-area-width="150px"
          slot-duration="00:15:00"
          slot-width="10%"
          :events="allEvents"
          now-indicator="true"
          @eventMouseEnter="eventMouseEnter"
          @eventMouseLeave="eventMouseLeave"
          :editable="false"
          height="auto"
          :droppable="false"
          :resources="onlyActiveResources"
          :business-hours="bussinessHours"
          @eventClick="eventClick"
          event-order="order"
          @datesRender="handleDateClick"
          :plugins="calendarPlugins"
          resource-order="-going_offline,-online"
      />

      <div @mouseenter="mouseOverTooltip = true" @mouseleave="mouseOverTooltip = false" class="booking-tooltip"
           :style="!tooltipStyle ? 'opacity: 0; display: none;' : tooltipStyle">
        <template v-if="!!tooltip.attach">
          <b>
            {{ tooltip.bookingFrom.format("HH:mm") }} - {{ tooltip.bookingTo.format("HH:mm") }}
          </b>
          <br>
          Service: {{ tooltip.bookingData.serviceName }}
          <br>
          from: {{ tooltip.bookingData.pick_up_location_name }}
          <br>
          to: {{ tooltip.bookingData.pull_down_location_name }}
          <br>
          <template v-if="tooltip.bookingData.min_pick_up_time">
            Pick up : {{ moment(tooltip.bookingData.min_pick_up_time).format("HH:mm") }} -
            {{ moment(tooltip.bookingData.max_pick_up_time).format("HH:mm") }}
            <br>
            Drop Off : {{ moment(tooltip.bookingData.min_drop_off_time).format("HH:mm") }} -
            {{ moment(tooltip.bookingData.max_drop_off_time).format("HH:mm") }}
            <br>
          </template>
          <b>
            <router-link :to="{name: 'PassengerProfile',params: {id: tooltip.bookingData.passengerId}}"
                         target="_blank">
              {{ tooltip.bookingData.passengerName }}
            </router-link>
          </b>
          <br>
          user: {{ tooltip.bookingData.user }}
          <br>
          delta: {{
            Math.floor(tooltip.bookingData.diffInMinutes /
                60)
          }}:{{ tooltip.bookingData.diffInMinutes % 60 }}
          <br>
          Estimated Time: {{ Number(tooltip.bookingData.estimated_time).toFixed(2) }}
          <br>
          Estimated Price: {{ Number(tooltip.bookingData.estimated_price).toFixed(2) }}
          <br>
          created at: {{ tooltip.bookingData.created_at }}
          <br>
          booking id : {{ tooltip.bookingData.bookingId }}
          <br>
          ride id : {{ tooltip.bookingData.ride_id }}
        </template>
      </div>
      <booking-editor v-if="!loading" v-model="activeBooking"/>
    </v-flex>
    <v-flex sm2 v-if="showRefused">
      <v-layout column wrap>
        <v-flex xs3 v-for="request in refused_requests">
          <request-card :item="request.booking" hide-approve/>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-dialog :value="!!dialog" @input="dialog = false" max-width="500px">
      <v-card>
        <v-card-title>
          <h2>
            <template v-if="dialog === 'checker'">
              Captain Checker
            </template>
            <template v-else-if="dialog === 'start-shift'">
              Set Start Shift
            </template>
          </h2>
        </v-card-title>
        <v-card-text>
          <v-checkbox v-if="dialog === 'checker'" label="Going offline" v-model="going_offline_option"></v-checkbox>
          <choose-captains-multi :multi="false" v-model="captain_id"></choose-captains-multi>
          <v-text-field v-if="dialog === 'start-shift'" type="datetime-local" v-model="start_shift"
                        label="Start Shift"/>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click="check">Set</v-btn>
          <v-btn color="default" flat @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="!!activeSuggestionId" @input="activeSuggestionId = null" lazy>
      <v-card v-if="!!this.activeSuggestion">
        <v-card>
          <v-card-title primary-title class="title font-weight-bold primary">
            Update Time Suggestion
          </v-card-title>
          <v-divider/>
          <v-card-actions>
            <v-btn primary @click="suggest">
              Send Suggestion Message
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
    <v-dialog :value="!!activePendingSuggestionId" @input="activePendingSuggestionId = null" lazy>
      <v-card v-if="!!activePendingSuggestionId">
        <v-card>
          <v-card-title primary-title class="title font-weight-bold primary">
            Confirm Suggestion
          </v-card-title>
          <v-divider/>
          <v-card-actions>
            <v-btn color="error" @click="declineSuggestion">
              Passenger Declined the Suggestion
            </v-btn>
            <v-btn primary @click="confirmSuggestion">
              Passenger Confirmed The Suggestion
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from "moment";
import FullCalendar from "@fullcalendar/vue";
import ResourceTimeline from "@fullcalendar/resource-timeline"
import FullCalendarMoment from "@fullcalendar/moment";
import FullCalendarInteraction from "@fullcalendar/interaction";
import LoadingComponent from "@/components/LoadingComponent";
import BookingEditor from "@/components/wasilni/BookingEditor";
import RidePage from "@/views/RidePage";
import RequestCard from "@/components/wasilni/RequestCard";
import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
import ChooseDate from "@/components/wasilni/input/ChooseDate";
import socketEventsMixin from "@/mixins/socketEventsMixin";
import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";

const colors = {
  Shift: '#FF005599',
  Online: '#8a02a7',
  WasOnline: '#566562',
  Ride: '#FF550099'
};

const bookingStatusColor = {
  APPROVED: '#f17cf7',
  ACCEPTED: '#8e8e88',
  STARTED: "#5abbca",
  ARRIVED: "#ffa60c",
  PICKED_UP: "#e04b4a",
  DONE: "#8b8e2a",
  PAID: "#127460",
  AI_SUGGESTION: "#ffdbc8",
  AI_UPDATETIME: "#cdedab",
  AI_UPDATETIME_PENDING: "#fff996"
};

export default {
  mixins: [socketEventsMixin, hasIntervalsMixin],
  name: "Timeline",
  title: 'Timeline',
  components: {
    ChooseCaptainsMulti,
    RequestCard,
    RidePage,
    LoadingComponent,
    FullCalendar,
    BookingEditor,
    ChooseDate
  },
  computed: {
    calendarPlugins() {
      return [ResourceTimeline, FullCalendarMoment, FullCalendarInteraction];
    },
    bookingColors() {
      return bookingStatusColor;
    },
    allEvents() {
      return [...this.events.map(event => {
        if (event.type !== "Booking")
          return event;
        const matching_end_ride = this.end_rides.find(item => item.ride_id === event.bookingData.ride_id);
        if (!matching_end_ride)
          return event;
        return Object.assign({}, event, {title: "(E)" + event.title});
      }), ...this.aiEvents];
    },
    showRefused() {
      return !this.hideRefused && this.refused_requests.length > 0;
    },
    Math() {
      return Math;
    },
    Number() {
      return Number;
    },
    step() {
      return 15 / 60;
    },
    min_range() {
      return 0;
    },
    max_range() {
      return 24 - 1 / 60;
    },
    min_time() {
      return moment().startOf('day').add(this.range[0], 'hours').format("HH:mm:00");
    },
    max_time() {
      return moment().startOf('day').add(this.range[1], 'hours').format("HH:mm:00");
    },
    activeSuggestion() {
      return this.aiEvents.filter(({id}) => id === this.activeSuggestionId)[0]
    },
    activePendingSuggestion() {
      return this.aiEvents.filter(({id}) => id === this.activePendingSuggestionId)[0];
    },
    onlyActiveResources() {
      return this.resources.filter(resource =>
          resource.title.indexOf('on') !== -1 || this.allEvents.filter(x => x.resourceId === resource.id).length > 0
      );
    }
  },
  updated() {
    let calendarApi = this.$refs.calendar.getApi();
    calendarApi.refetchEvents();
  },
  data() {
    return {
      tooltipStyle: null,
      range: [
        0, 0
      ],
      mouseOverTooltip: false,
      bussinessHours: false,
      tooltip: {},
      sliderTouched: false,
      hideRefused: false,
      activeRideId: null,
      date: null,
      loading: 0,
      events: [],
      resources: [],
      activeBooking: null,
      refused_requests: [],
      aiEvents: [],
      dialog: false,
      start_shift: null,
      going_offline_option: false,
      captain_id: null,
      autoUpdate: true,
      activeSuggestionId: null,
      activePendingSuggestionId: null,
      end_rides: []
    }
  },
  watch: {
    mouseOverTooltip(val) {
      if (!val)
        this.tooltipStyle = null;

    },
    date() {
      this.reload();
    },
    showRefused() {
      setTimeout(() =>
              this.$refs.calendar.getApi().updateSize()
          , 100);
    },
    min_time(val) {
      this.$refs.calendar.getApi().setOption('minTime', val);
      this.$refs.calendar.getApi().refetchEvents()
    },
    max_time(val) {
      this.$refs.calendar.getApi().setOption('maxTime', val);
      this.$refs.calendar.getApi().refetchEvents()
    }
  },
  methods: {
    update_end_ride({captain_id, ride_id}) {
      captain_id = captain_id + "";
      ride_id = ride_id + "";
      this.end_rides = [...this.end_rides, {captain_id, ride_id}];
    },
    suggest() {
      this.loading += 1;
      this.axios.post('booking/' + this.activeSuggestionId + '/suggest', {
        new_time: moment(moment(this.activeSuggestion.start)).format("YYYY-MM-DD HH:mm"),
        captain_id: this.activeSuggestion.resourceId.split("captain-")[1]
      }).finally(
          () => this.loading -= 1
      );
      this.activeSuggestionId = null;
    },
    getEndRides() {
      this.loading += 1;
      this.axios.get(this.api.ACTIONS.ALL_END_RIDES)
          .then(
              ({data: {data}}) => this.end_rides = data
          )
          .catch(
              ({response: {data: {message}}}) => window.getApp.$emit("SHOW_TOAST", "error", message)
          )
          .finally(
              () => this.loading -= 1
          )
    },
    confirmSuggestion() {
      this.loading += 1;
      this.axios.post('booking/' + this.activePendingSuggestionId + '/confirm_suggestion')
          .finally(
              () => this.loading -= 1
          );
      this.activePendingSuggestionId = null;
    },
    declineSuggestion() {
      this.loading += 1;
      this.axios.post('booking/' + this.activePendingSuggestionId + '/refuse_suggestion')
          .finally(
              () => this.loading -= 1
          );
      this.activePendingSuggestionId = null;
    },
    updateRange(start, end) {
      this.range = [start.toFixed(2), end.toFixed(2)];
    },
    check() {
      if (!this.captain_id)
        return;
      this.loading += 1;
      if (this.dialog === 'checker')
        this.axios.put(`check?captain_id=${this.captain_id}${this.going_offline_option ? '&going_offline=1' : ''}`)
            .then(res => {
              window.getApp.$emit("SHOW_TOAST", `captain ${res.data.data.state ? "online" : "offline"} check completed successfully`, "green");
              this.dialog = false;
            }).catch(err => window.getApp.$emit("SHOW_TOAST", err.message, "green"))
            .finally(() => this.loading -= 1);
      else if (this.dialog === 'start-shift') {
        if (!this.start_shift) {
          this.loading -= 1;
          return;
        }

        this.axios.put(`captain/${this.captain_id}/start_shift`, {
          start_shift: moment(this.start_shift).format("YYYY-MM-DD HH:mm")
        }).then(
            () => {
              window.getApp.$emit("SHOW_TOAST", "Start shift Saved!");
              this.dialog = false;
              this.start_shift = null;
            }
        ).catch(
            ({response: {data}}) => window.getApp.$emit("SHOW_TOAST", data.message, "red")
        ).finally(
            () => this.loading -= 1
        )
      }

    },
    createBooking(bookingId, bookingDate, passengerId, passengerName, captainId, status, estimated_time, bookingData) {
      if (!bookingData.passengerId) {
        bookingData.passengerId = passengerId;
        bookingData.passengerName = passengerName;
      }
      if (typeof bookingData.user != 'string') {
        bookingData.user = bookingData.user.first_name + " " + bookingData.user.last_name;
      }
      if (!bookingData.bookingId) {
        bookingData.bookingId = bookingData.id ? bookingData.id : 1;
      }
      if (!bookingData.ride_id) {
        bookingData.ride_id = 'Not Dispatched Yet';
      }
      if (!bookingData.estimated_time) {
        bookingData.estimated_time = estimated_time;
        bookingData.estimated_price = bookingData.summary ? bookingData.summary.estimated_price : 'N\\A';
      }
      if (!bookingData.bookingDate) {
        bookingData.bookingDate = bookingDate;
      }
      if (!bookingData.serviceName && !!bookingData.service) {
        bookingData.serviceName = bookingData.service.name;
      }
      return {
        resourceId: 'captain-' + captainId,
        title: passengerName,
        type: 'Booking',
        start: moment(bookingDate).toDate(),
        end: !estimated_time || estimated_time === "null" ? moment(bookingDate).add(1, 'hour').toDate() : moment(bookingDate).add(estimated_time, 'minute').toDate(),
        id: Number(bookingId),
        order: 1,
        color: bookingStatusColor[status],
        status,
        bookingData
      }
    },

    checkLastState(captainId, state, events){
        if (!events || !events.length){
          return true
        }
        const captainEvents = events.filter(event => event.resourceId === `captain-${captainId}`)

        if (!captainEvents.length){
          return true
        }
        return captainEvents[captainEvents.length - 1].type != state
    },


    reload() {
      this.loading += 1;
      const params = new URLSearchParams();
      params.append('date', this.date);
      this.axios.get(this.api.ACTIONS.TIMELINE, {params}).then(
          ({data: {data}}) => {
            const newResources = [];
            const newEvents = [];
            for (let {captain_id, captain_name, booking_periods, online, check_log, schedule, rides, going_offline, going_offline_destination} of data) {
              going_offline = Number.parseInt(going_offline);
              newResources.push(
                  this.createResource(captain_id, captain_name + (going_offline ? `[go-${going_offline_destination}]` : (online ? '[on]' : '[off]')), online + 1, going_offline)
              );
              if (!!schedule)
                for (let log of schedule.split(',')) {
                  const start = moment(this.date + ' ' + log.split('|')[1]).toDate();
                  const end = moment(this.date + ' ' + log.split('|')[2]).toDate();
                  newEvents.push(
                      this.createEvent('Shift', start, end, captain_id, log.split('|')[0], "", -1)
                  );
                }
              if (!!booking_periods)
                for (let booking of booking_periods.split(',')) {
                  try {
                    let [bookingId, bookingDate, passengerId,
                      pick_up_location_name, pull_down_location_name, user,
                      status, diffInMinutes, created_at,
                      ride_id, estimated_time, estimated_price, serviceName, passengerName, ...rest
                    ] = booking.split('|');
                    if (rest.length > 0) {
                      passengerName = passengerName + '|' + rest.join('|');
                    }
                    const bookingData = {
                      bookingId,
                      bookingDate,
                      passengerId,
                      pick_up_location_name,
                      pull_down_location_name,
                      user,
                      status,
                      diffInMinutes,
                      estimated_time,
                      estimated_price,
                      created_at,
                      ride_id,
                      serviceName,
                      passengerName
                    };

                    newEvents.push(
                        this.createBooking(
                            eval(bookingId),
                            bookingDate,
                            passengerId,
                            passengerName,
                            captain_id,
                            status,
                            estimated_time,
                            bookingData
                        )
                    );
                  } catch (e) {
                    console.log("malformed booking : ", booking);
                  }
                }
              if (!!check_log)
                for (let log of check_log.split(',')) {
                  const isOnline = log.split('|')[2] == 'null';
                  if (this.checkLastState(captain_id, isOnline ? 'Online' : 'WasOnline', newEvents)){
                    newEvents.push(
                        this.createEvent(isOnline ? 'Online' : 'WasOnline',
                            moment(log.split('|')[1]).toDate(),
                            log.split('|')[2] !== 'null' ? moment(log.split('|')[2]).toDate() : moment(this.date).endOf('day').toDate(),
                            captain_id,
                            log.split('|')[0],
                            '',
                            0)
                    );
                  }

                }
              if (!!rides)
                for (let ride of rides.split(',')) {
                  const [rideId, rideStart, bookingsCount] = ride.split("|");
                  if (bookingsCount > 1)
                    newEvents.push(
                        this.createEvent(
                            'Ride',
                            moment(rideStart).toDate(),
                            newEvents.filter(i => !!i.bookingData && i.bookingData.ride_id == rideId).reduce((r, i) => Math.max(r, i.end), null),
                            captain_id,
                            rideId,
                            '#' + rideId, 2)
                    );
                }
            }
            this.resources = newResources;
            this.events = newEvents;
          }
      )
          .finally(
              () =>
                  this.loading -= 1
          )
    },
    eventClick({event, jsEvent: {ctrlKey: isCtrlPressed}}) {
      if (!event.extendedProps.bookingData || 'AI_SUGGESTION' === event.extendedProps.status)
        return 1;
      else if (event.extendedProps.status === 'AI_UPDATETIME')
        this.activeSuggestionId = Number(event.id);
      else if (event.extendedProps.status === 'AI_UPDATETIME_PENDING')
        this.activePendingSuggestionId = Number(event.id);
      else if (!!event.extendedProps.bookingData && !['DONE', 'PAID', 'PICKED_UP'].includes(event.extendedProps.bookingData.status) && isCtrlPressed)
        this.activeBooking = Number(event.id);
      else if (!!event.extendedProps.bookingData && !isCtrlPressed)
        this.activeRideId = event.extendedProps.bookingData.ride_id;
    },
    createEvent(type, start, end, captain_id, id, extra = '', order = 1) {
      return {
        resourceId: 'captain-' + captain_id,
        title: type + extra,
        type,
        start,
        end,
        id: Number(id),
        order,
        color: colors[type]
      }
    },
    createResource(captain_id, captain_name, online, going_offline) {
      return {id: 'captain-' + captain_id, title: captain_name, online, going_offline};
    },
    handleDateClick({view}) {
      this.date = moment(view.activeStart).format("YYYY-MM-DD")
    },
    ai_timeline(data) {
      this.refused_requests = data.refused_requests.filter(i => !i.virtual);
      const pending_suggestions = data.refused_requests.filter(i => i.virtual);
      this.aiEvents = [];

      for (let {task_id, virtual_data, booking} of pending_suggestions) {
        this.aiEvents = [...this.aiEvents,
          this.createBooking(
              task_id,
              virtual_data.time,
              booking.passenger_id,
              booking.passenger.first_name + ' ' + booking.passenger.last_name,
              virtual_data.captain,
              'AI_UPDATETIME_PENDING',
              booking.summary.estimated_time,
              booking
          )
        ]
      }

      for (let driver of data.workers) {
        for (let {task_id, min_pick_up_time, max_pick_up_time, min_drop_off_time, booking, virtual} of driver.worker_rides) {
          this.aiEvents = [...this.aiEvents,
            this.createBooking(
                task_id,
                moment(min_pick_up_time).add(moment(max_pick_up_time).diff(min_pick_up_time, 'minutes') / 2, 'minutes').toDate(),
                booking.passenger_id,
                booking.passenger.first_name + ' ' + booking.passenger.last_name,
                driver.worker_id,
                virtual ? 'AI_UPDATETIME' : 'AI_SUGGESTION',
                moment(min_drop_off_time).diff(moment(min_pick_up_time), 'minutes'),
                booking,
            )
          ]
        }
      }

    },
    eventMouseEnter({event, el, jsEvent}) {
      setTimeout(() => {
        if (this.mouseOverTooltip)
          return;
        if (!!event.extendedProps.bookingData) {
          const fullCalendarScrollers = this.$refs.calendar.getApi().el.getElementsByClassName("fc-scroller");
          const {clientX: x, clientY: y} = jsEvent;
          this.tooltipStyle = `position: fixed; top: ${y}px; left: ${x + 10}px; opacity: 1;`;
          const bookingData = event.extendedProps.bookingData;
          const bookingFrom = moment(bookingData.bookingDate);
          const bookingTo = moment(bookingFrom).add(bookingData.estimated_time, 'minutes');
          this.tooltip = {
            attach: el,
            bookingData,
            bookingFrom,
            bookingTo
          };
        } else {
          this.tooltipStyle = null;
        }
      }, 100);
    },
    eventMouseLeave({event}) {
      setTimeout(() => {
        if (this.mouseOverTooltip)
          return;
        if (!!event.extendedProps.bookingData)
          this.tooltipStyle = null;
      }, 100);
    },
    updateRangeIfApplicable() {
      const currentTime = moment();
      const currentStart = moment(this.date + " " + this.min_time);
      const currentEnd = moment(this.date + " " + this.max_time);
      if (currentTime.isBetween(currentStart, currentEnd)) {
        const newStart = currentStart.add(30, 'minutes').diff(moment().startOf('day'), 'hours', true);
        const newEnd = currentEnd.add(30, 'minutes').diff(moment().startOf('day'), 'hours', true);
        this.updateRange(newStart, newEnd);
      }
    },
    updateBookingStatus(bookingId, status) {
      if (['REJECTED', 'CANCELLED'].includes(status))
        this.events = this.events.filter(
            event => !(event.type === 'Booking' && event.id === bookingId)
        );
      else
        this.events = this.events.map(
            event => {
              if (event.type === 'Booking' && event.id === bookingId) {
                event = Object.assign({}, event, {status, color: bookingStatusColor[status]});
              }
              return event;
            }
        )
    },
    updateBookingCaptain(bookingId, captainId) {
      this.events = this.events.map(
          event => {
            if (event.type === 'Booking' && event.id === bookingId)
              event = Object.assign({}, event, {resourceId: 'captain-' + captainId});
            return event;
          }
      );
    },
    updateBookingTime(bookingId, time) {
      this.events = this.events.map(
          event => {
            if (event.type === 'Booking' && event.id === bookingId) {
              const estimated_time = moment(event.end).diff(moment(event.start), 'minutes');
              event.start = moment(time).toDate();
              event.end = moment(time).add(estimated_time, 'minutes').toDate();
            }
            return event;
          }
      )
    },
    goingOffline(data) {
      let captain_id = data.captain_id;
      const resourceObject = this.resources.filter(({id}) => id === 'captain-' + captain_id)[0];
      if (!resourceObject) return;
      let captainName = resourceObject.title.split(/\[\w+]/)[0];
      this.resources = this.resources.map(
          (resource) => {
            if (resource.id === 'captain-' + captain_id)
              return {
                id: resource.id,
                title: captainName + `[go-${data.destination}]`,
                online: resource.online,
                going_offline: true
              };
            return resource;
          }
      );
    },
    captainCheck(captainId, checkId) {
      this.end_rides = this.end_rides.filter(i => i.captain_id != captainId);
      const resourceObject = this.resources.filter(({id}) => id === 'captain-' + captainId)[0];
      if (!resourceObject) return;
      let online = !(resourceObject.online - 1);
      let captainName = resourceObject.title.split(/\[\w+]/)[0];
      this.resources = this.resources.map(
          (resource) => {
            if (resource.id === 'captain-' + captainId)
              return {
                id: resource.id,
                title: captainName + (online ? '[on]' : '[off]'),
                online: online + 1,
                going_offline: false
              };
            return resource;
          }
      );

      if (!online) {
        const lastEvent = this.events.filter(event => event.type === 'Online' && event.resourceId === resourceObject.id)[0];
        if (!lastEvent)
          return;
        this.events = this.events.map(
            (event) => {
              if (JSON.stringify(event) !== JSON.stringify(lastEvent))
                return event;
              return Object.assign({}, lastEvent, {
                title: "WasOnline",
                end: moment().toDate(),
                color: colors["WasOnline"]
              });
            }
        )
      } else {
        this.events = [...this.events,
          this.createEvent('Online', moment().toDate(), checkId, captainId, checkId)
        ];
      }
    },
    bookingDispatched(bookingId,
                      bookingDate,
                      passengerId,
                      pick_up_location_name,
                      pull_down_location_name,
                      user,
                      status,
                      diffInMinutes,
                      estimated_time,
                      estimated_price,
                      created_at,
                      ride_id,
                      passengerName,
                      captain_id) {
      const bookingData = {
        bookingId,
        bookingDate,
        passengerId,
        pick_up_location_name,
        pull_down_location_name,
        user,
        status,
        diffInMinutes,
        estimated_time,
        estimated_price,
        created_at,
        ride_id,
        passengerName
      };
      this.events = [...this.events,
        this.createBooking(
            eval(bookingId),
            bookingDate,
            passengerId,
            passengerName,
            captain_id,
            status,
            estimated_time,
            bookingData
        )
      ];
    }

  },
  mounted() {
    const startMoment = moment().subtract(1.5, 'hours');
    const endMoment = moment().add(2, 'hours');
    const startRange = parseInt(startMoment.format("HH")) + parseInt(startMoment.format("mm")) / 60;
    let endRange = parseInt(endMoment.format("HH")) + parseInt(endMoment.format("mm")) / 60;

    if (endRange <= startRange) {
      endRange = 23 + 55 / 60;
    }

    this.getEndRides();

    this.updateRange(startRange, endRange);
  },
  intervals() {
    return [
      [this.updateRangeIfApplicable, 30 * 60 * 1000],
      [() => {
        const startTime = moment().subtract(5, "minutes").format("HH:mm");
        let endTime = moment().add(40, "minutes").format("HH:mm");

        if (endTime < startTime)
          endTime = "23:59";

        this.bussinessHours = {startTime, endTime}
      }
        , 1000]
    ];
  },
  events() {
    return {
      'Ai:timeline': this.ai_timeline,
      'Timeline:update_booking_status': this.updateBookingStatus,
      'Timeline:update_booking_captain': this.updateBookingCaptain,
      'Timeline:update_booking_time': this.updateBookingTime,
      'Timeline:captain_check': this.captainCheck,
      'Timeline:booking_dispatched': this.bookingDispatched,
      'Dashboard:going_offline': this.goingOffline,
      [this.api.SOCKET.EVENTS.UPDATE_END_RIDE]: this.update_end_ride
    };
  }
}
</script>

<style lang="scss">
@import '~@fullcalendar/resource-timeline/main.css';
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/timeline/main.css';

.booking-tooltip {
  position: absolute;
  float: left;
  padding: 8px;
  z-index: 10;
  background-color: #c5c5c5ee;
  transition: opacity 100ms;

  * {
    background-color: unset;
  }
}

</style>
